import React, {ReactElement} from 'react';
import {IElementButton} from '../../../incase-domain/elements/button';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';

interface ElementButtonComponentProps {
    element: IElementButton;
    device?: DeviceType;
}

function ElementButtonComponent(props: ElementButtonComponentProps): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;
    const {icon, text} = element;

    function renderIcon(): JSX.Element {
        if (icon) {
            return <img style={{width: `${icon.width}em`, height: `${icon.height}em`}} src={icon.src} alt="" />;
        }

        return <></>;
    }

    return (
        <button type="button" style={getElementStyle(device, element)} className={getElementClasses(device)}>
            {text}
            {renderIcon()}
        </button>
    );
}

function getElementStyle(device: DeviceType, element: IElementButton): React.CSSProperties {
    if (device === DeviceType.MOBILE) {
        return {
            background: element.color,
            color: element.font.color,
            fontFamily: element.fontFamily?.name,
        };
    }

    return {
        fontSize: `${element.font.size}em`,
        background: element.color,
        color: element.font.color,
        fontFamily: element.fontFamily?.name,
    };
}

function getElementClasses(device: DeviceType): string {
    if (device === DeviceType.MOBILE) {
        return 'c-buttonElement c-buttonElement--mobile';
    }

    return 'c-buttonElement';
}

export default ElementButtonComponent;
